import { SelectInput } from 'client/components/common/SelectInput/SelectInput'
import { Analytics, checkPlacement } from 'client/Global/Analytics'
import { AnalyticsType, Category, Events, Result } from 'client/Global/AnalyticsEvents'
import { Segment } from 'client/Global/Segment'
import { SegmentEvents } from 'client/Global/SegmentEvents'
import { l } from 'client/Other/Translation'
import * as React from 'react'

export const fontOptions = {
  arvo: 'Arvo',
  baskervville: 'Baskervville',
  bitter: 'Bitter',
  fahkwang: 'Fahkwang',
  georama: 'Georama',
  ibmPlexSansCondensed: 'IBM Plex Sans Condensed',
  krub: 'Krub',
  libreBaskerville: 'Libre Baskerville',
  openSans: 'Open Sans',
  playfair: 'Playfair',
  poppins: 'Poppins',
  quicksand: 'Quicksand',
  roboto: 'Roboto',
  robotoCondensed: 'Roboto Condensed',
  robotoMono: 'Roboto Mono',
  rokkitt: 'Rokkitt',
  sen: 'Sen',
  solway: 'Solway',
  spaceMono: 'Space Mono',
  varelaRound: 'Varela Round',
  volkhov: 'Volkhov',
  workSans: 'Work Sans',
  zillaSlab: 'Zilla Slab',
}

export const FontDropdown = ({ settings, setSettings, changedValues, setChangedValues }) => {
  const handleClick = (font) => {
    Segment.track(SegmentEvents.invoiceCustomise.invoiceCustomised, { invoice_font_changed: font })
    setSettings({
      loaded: true,
      modified: true,
      customSettings: {
        ...settings,
        settings: {
          ...settings.settings,
          font,
        },
      },
    })
    setChangedValues({ ...changedValues, font: true })
    Analytics.trackEvent(Events.selectMainFont, {
      type: AnalyticsType.action,
      category: Category.setting,
      result: Result.success,
      placement: checkPlacement(window.location.pathname),
      font,
    })
  }

  return (
    <SelectInput
      label={l('customTemplates.templateFont')}
      openDirection={'down'}
      value={settings.settings.font}
      map={fontOptions}
      onChange={(value) => handleClick(value)}
      searchable={true}
      customClass={true}
    />
  )
}
